import React from 'react';

import { pdf } from '@react-pdf/renderer';

import EvaluationDocument from './evaluationDocument';
import { evalFileName } from './helpers';

// CP-854 — render the evaluation report on press and hand it to the browser.
//
// Note we do NOT use <PDFDownloadLink> the way QuoteEngine does: it renders its document eagerly
// on mount (hence the 3-second `mounted` workaround in QuoteEngine/ViewQuote), which would mean
// rendering up to 100 PDFs just to paint the audit table. pdf().toBlob() renders on demand.
//
// The anchor goes into the document before it is clicked and the object URL is released on a later
// tick, matching SearchDQF and TimeOffRequests. Revoking in the same tick as the click can cancel
// the download before the browser has finished reading the blob — a few-KB CSV survives that race,
// a multi-hundred-KB PDF need not.
//
// Errors propagate so the page can surface them inline.
export const downloadEvaluationPdf = async (audit, header, dqfId) => {
  const blob = await pdf(<EvaluationDocument audit={audit} header={header} dqfId={dqfId} />).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${evalFileName(audit)}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export default downloadEvaluationPdf;
